import { http } from "@/service/config";

const CHAVE_SESSAO = "sessao2fa";

export default {
  // --- chamadas à API ---
  status: () => http.get("/auth/2fa/status"),
  iniciarCadastro: () => http.post("/auth/2fa/enroll/iniciar"),
  confirmarCadastro: (codigo) => http.post("/auth/2fa/enroll/confirmar", { codigo }),
  verificar: (codigo) => http.post("/auth/2fa/verificar", { codigo }),
  logout: () => http.post("/auth/2fa/logout"),

  // --- token de sessão 2FA no navegador ---
  guardarSessao: (token) => localStorage.setItem(CHAVE_SESSAO, token),
  obterSessao: () => localStorage.getItem(CHAVE_SESSAO),
  limparSessao: () => localStorage.removeItem(CHAVE_SESSAO),
  temSessao: () => !!localStorage.getItem(CHAVE_SESSAO),
  CHAVE_SESSAO,
};
